import { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

export default function Tr({ children }: Props) {
  return <tr className="border-0">{children}</tr>
}
